import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API, RISKMGT } from '@const'
import * as utils from '@utils'
import { Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, InputAdornment } from '@material-ui/core'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'

const initialState = {
    input: {
        oid: 0,
        pf_sub_pf_id: '',
        threshold_prevention_red: 0,
        game_risk_info_prevention_red_ban_score: 0,
        threshold_prevention_yellow: 0,
        game_risk_info_prevention_yellow_ban_score: 0,
        tip_rate: 0,
    },
    dialogOpen: false,
    isLoading: false,
}

class EditWaterPoolDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'EditWaterPoolDialog', options)
        }
        this.state = initialState
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    data
    isMultiple

    reset(inputs, isMultiple) {
        this.isMultiple = isMultiple
        isMultiple
            ? this.setState({
                  input: {
                      ...initialState.input,
                  },
              }) || (this.data = inputs)
            : this.setState({
                  input: {
                      ...inputs,
                      game_risk_info_prevention_red_ban_score:
                          this.props.owner.gameRiskInfoList[
                              utils.ComposeGameRiskInfoKey(inputs.oid, RISKMGT.RISK_LABEL_WATERPOOL_PREVENTION_RED, inputs.pf_sub_pf_id)
                          ].ban_score,
                      game_risk_info_prevention_yellow_ban_score:
                          this.props.owner.gameRiskInfoList[
                              utils.ComposeGameRiskInfoKey(inputs.oid, RISKMGT.RISK_LABEL_WATERPOOL_PREVENTION_YELLOW, inputs.pf_sub_pf_id)
                          ].ban_score,
                  },
                  isLoading: false,
              })
    }

    OpenDialog(inputs, isMultiple) {
        this.reset(inputs, isMultiple)
        this.setState({ dialogOpen: true })
    }

    closeDialog() {
        this.setState({ dialogOpen: false })
    }

    confirm() {
        if (this.props.confirmCallback) {
            this.props.confirmCallback()
        }
        this.closeDialog()
    }

    render() {
        return (
            <Dialog open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })}>
                <DialogTitle>
                    {this.t('title', {
                        game_name: this.t('GameName.' + this.state.input.game_code),
                    })}
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                label={this.t('thresholdPreventionRed')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.input.threshold_prevention_red}
                                onChange={(event) => {
                                    let value = parseInt(event.target.value)
                                    if (value < 0 || isNaN(value)) {
                                        value = 0
                                    }

                                    this.setState({
                                        input: {
                                            ...this.state.input,
                                            threshold_prevention_red: value,
                                        },
                                    })
                                }}
                                margin="dense"
                            />
                        </Grid>
                        {!RISKMGT.BAN_SCORE_NOT_SUPPORT.includes(this.state.input.oid) ? (
                            <Grid item xs={12}>
                                <TextField
                                    label={this.t('gameRiskInfoPreventionRedBanScore')}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={this.state.input.game_risk_info_prevention_red_ban_score}
                                    onChange={(event) => {
                                        let value = parseInt(event.target.value)
                                        if (value < 0 || isNaN(value)) {
                                            value = 0
                                        }

                                        this.setState({
                                            input: {
                                                ...this.state.input,
                                                game_risk_info_prevention_red_ban_score: value,
                                            },
                                        })
                                    }}
                                    margin="dense"
                                />
                            </Grid>
                        ) : (
                            ''
                        )}
                        <Grid item xs={12}>
                            <TextField
                                label={this.t('thresholdPreventionYellow')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.input.threshold_prevention_yellow}
                                onChange={(event) => {
                                    let value = parseInt(event.target.value)
                                    if (value < 0 || isNaN(value)) {
                                        value = 0
                                    }

                                    this.setState({
                                        input: {
                                            ...this.state.input,
                                            threshold_prevention_yellow: value,
                                        },
                                    })
                                }}
                                margin="dense"
                            />
                        </Grid>
                        {!RISKMGT.BAN_SCORE_NOT_SUPPORT.includes(this.state.input.oid) ? (
                            <Grid item xs={12}>
                                <TextField
                                    label={this.t('gameRiskInfoPreventionYellowBanScore')}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={this.state.input.game_risk_info_prevention_yellow_ban_score}
                                    onChange={(event) => {
                                        let value = parseInt(event.target.value)
                                        if (value < 0 || isNaN(value)) {
                                            value = 0
                                        }

                                        this.setState({
                                            input: {
                                                ...this.state.input,
                                                game_risk_info_prevention_yellow_ban_score: value,
                                            },
                                        })
                                    }}
                                    margin="dense"
                                />
                            </Grid>
                        ) : (
                            ''
                        )}
                        <Grid item xs={2}>
                            <TextField
                                label={this.t('tipRate')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.input.tip_rate}
                                onChange={(event) => {
                                    let value = Math.max(event.target.value, 0)
                                    if (Number.isNaN(value)) value = 0
                                    this.setState({
                                        input: {
                                            ...this.state.input,
                                            tip_rate: value,
                                        },
                                    })
                                }}
                                margin="dense"
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                }}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={() => {
                            this.setState({ isLoading: true })

                            if (
                                parseInt(this.state.input.threshold_prevention_red) >= parseInt(this.state.input.threshold_prevention_yellow) ||
                                parseInt(this.state.input.game_risk_info_prevention_red_ban_score) >
                                    parseInt(this.state.input.game_risk_info_prevention_yellow_ban_score)
                            ) {
                                utils.addToast(this.t('invalidParams'), 'error')
                                this.setState({ isLoading: false })
                                return
                            }

                            if (this.isMultiple) {
                                const promiseList = []
                                this.data.forEach((elem) => {
                                    const promise = new Promise((resolve, reject) => {
                                        utils.apiRequest(
                                            'put',
                                            API.JACKPOT,
                                            {
                                                ...elem,
                                                reward_pool: parseInt(this.state.input.reward_pool),
                                                threshold: parseInt(this.state.input.threshold),
                                                maximum: parseInt(this.state.input.maximum),
                                            },
                                            (_data) => {
                                                resolve()
                                            },
                                            () => {
                                                reject()
                                            }
                                        )
                                    })
                                    promiseList.push(promise)
                                })
                                Promise.all(promiseList)
                                    .then(() => {
                                        this.confirm()
                                    })
                                    .catch(() => {
                                        this.setState({ isLoading: false })
                                    })
                            } else {
                                const promiseList = []

                                const updateJackpotPromise = new Promise((resolve, reject) => {
                                    utils.apiRequest(
                                        'patch',
                                        API.RISKMGT_WATERPOOL,
                                        {
                                            oid: this.state.input.oid,
                                            pf_sub_pf_id: this.state.input.pf_sub_pf_id,
                                            threshold_prevention_red: parseInt(this.state.input.threshold_prevention_red),
                                            threshold_prevention_yellow: parseInt(this.state.input.threshold_prevention_yellow),
                                            tip_rate: parseInt(this.state.input.tip_rate),
                                        },
                                        (_data) => {
                                            resolve()
                                        },
                                        () => {
                                            reject()
                                        },
                                        true
                                    )
                                })
                                promiseList.push(updateJackpotPromise)

                                const updateRiskLabelRedPromise = new Promise((resolve, reject) => {
                                    utils.apiRequest(
                                        'patch',
                                        API.RISKMGT_GAME_RISK_INFO,
                                        {
                                            id: this.props.owner.gameRiskInfoList[
                                                utils.ComposeGameRiskInfoKey(
                                                    this.state.input.oid,
                                                    RISKMGT.RISK_LABEL_WATERPOOL_PREVENTION_RED,
                                                    this.state.input.pf_sub_pf_id
                                                )
                                            ].id,
                                            ban_score: parseInt(this.state.input.game_risk_info_prevention_red_ban_score),
                                        },
                                        (_data) => {
                                            resolve()
                                        },
                                        () => {
                                            reject()
                                        },
                                        true
                                    )
                                })
                                promiseList.push(updateRiskLabelRedPromise)

                                const updateRiskLabelYellowPromise3 = new Promise((resolve, reject) => {
                                    utils.apiRequest(
                                        'patch',
                                        API.RISKMGT_GAME_RISK_INFO,
                                        {
                                            id: this.props.owner.gameRiskInfoList[
                                                utils.ComposeGameRiskInfoKey(
                                                    this.state.input.oid,
                                                    RISKMGT.RISK_LABEL_WATERPOOL_PREVENTION_YELLOW,
                                                    this.state.input.pf_sub_pf_id
                                                )
                                            ].id,
                                            ban_score: parseInt(this.state.input.game_risk_info_prevention_yellow_ban_score),
                                        },
                                        (_data) => {
                                            resolve()
                                        },
                                        () => {
                                            reject()
                                        },
                                        true
                                    )
                                })
                                promiseList.push(updateRiskLabelYellowPromise3)

                                Promise.all(promiseList)
                                    .then(() => {
                                        utils.addToast(this.t('success'), 'success')
                                        this.confirm()
                                    })
                                    .catch(() => {
                                        this.setState({ isLoading: false })
                                    })
                            }
                        }}
                        color="primary"
                        disabled={this.state.isLoading}>
                        {this.t('confirm')}
                    </Button>
                    <Button variant="contained" onClick={() => this.closeDialog()} color="secondary">
                        {this.t('cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (_theme) => {
    return {
        editorToolbar: {
            border: 'solid 1px',
            margin: '12px 0',
            borderColor: 'rgba(0, 0, 0, 0.3)',
        },
        editorWrapper: {},
        editorEditor: {
            height: '300px',
            padding: '0 14px',
            border: 'solid 1px',
            borderColor: 'rgba(0, 0, 0, 0.3)',
        },
    }
}

EditWaterPoolDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
    owner: PropTypes.object,
}

export default hoc(styles)(EditWaterPoolDialog)
